// Formato de importes en la moneda de la empresa. No se convierte entre monedas.
export const CURRENCIES = ['EUR', 'USD', 'CAD', 'MXN', 'ARS', 'CLP', 'COP', 'HTG'];

export const formatMoney = (value, lang, currency) => {
  const cur = CURRENCIES.includes(currency) ? currency : 'EUR';
  const amount = Number(value) || 0;
  try {
    return new Intl.NumberFormat(lang || 'es', { style: 'currency', currency: cur }).format(amount);
  } catch (err) {
    return `${cur} ${amount.toFixed(2)}`;
  }
};
